
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout, mudarUser, mudarTitle } from '../../../../actions/AppActions';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

// users
import moment from 'moment';
import { URL } from '../../../../variables';
import ReactPaginate from 'react-paginate';
import { maskPrice } from '../../../Auxiliar/Masks';
import ReactTooltip from 'react-tooltip';

class Gerentes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            gerentes: [],
            page: 1,
            total_pages: 1,
            msgErro: '',
            show_warning: false,
            show_erro: false,
            gerente_to_delete: '',
        };
    }






    componentDidMount() {

        this.get_gerentes(this.props.empresa_id);
    }

    get_gerentes(id) {
        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/minha_empresa/get_gerentes?id=${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({ gerentes: resp.gerentes, empresa: resp.empresa, loading_screen: false });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }


    delete_gerente(id) {

        fetch(`${URL}api/minha_empresa/delete_gerente/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ msgErro: erro, show_warning: false, show_erro: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({ show_warning: false });
                    this.get_gerentes(this.props.empresa_id);
                    // this.setState({ users: resp.users, loading_screen: false, page: resp.pagination.current_page, total_pages: resp.pagination.last_page });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }







    render() {
        return (
            <div className="row">

                <div className="col-12">
                    <br />


                    {/* <hr /> */}
                    {this.state.loading_screen == false && <div>

                        <p style={{ fontSize: '1rem', color: 'black', marginBottom: '.25rem' }}><b style={{ fontWeight: 'bold' }}>Gerentes:</b></p>                        <div className="row mb-2">
                            <div className="col-12 col-md-6">

                            </div>

                            <div className="col-12 col-md-6 d-flex justify-content-end">
                                <Link to={"/empresas/gerentes/adicionar/" + this.props.empresa_id}><span
                                    className="btn btn-primary waves-effect waves-light" >Adicionar gerente</span></Link>
                            </div>
                        </div>
                        <div className="table-rep-plugin">
                            <div className="table-responsive mb-0" data-pattern="priority-columns">
                                <table id="tech-companies-1" className="table table-striped">
                                    <thead>
                                        <tr>

                                            <th>Nome</th>
                                            <th>E-mail</th>
                                            {/* <th  ></th> */}
                                            {this.props.user.role_name == 'empresa' && <th  >Ações</th>}

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.gerentes.map((item, id) => (

                                            <tr key={id}>

                                                <th>
                                                    {/* <img src={URL+item.fotos[0].foto} style={{height:60,width:60,objectFit:'contain',marginRight:10}} /> */}
                                                    {item.name}
                                                </th>
                                                <td>{item.email}</td>

                                                {/* <td>{item.estoque}</td> */}

                                                {this.props.user.role_name == 'empresa' && <td>
                                                <ReactTooltip />

                                                    <Link data-tip="Editar Gerente" to={'/empresas/gerentes/editar/' + item.id + '/' + this.props.empresa_id}><span className="btn btn-info btn-outline btn-circle m-r-5"
                                                        data-toggle="tooltip"
                                                    ><i className="ti-pencil-alt"></i></span></Link>
                                                    <button data-tip="Excluir Gerente" onClick={() => {
                                                        this.setState({ show_warning: true, gerente_to_delete: item.id });
                                                    }}
                                                        className="destroy_it btn btn-danger btn-outline btn-circle m-r-5"><i
                                                            className="ti-trash"></i></button>
                                                </td>}

                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {this.state.gerentes.length == 0 && <div className="row w-100">
                            <div className="col-12">
                                <p style={{ textAlign: 'center' }}>Nenhum gerente vinculado</p>

                            </div>
                        </div>}




                        {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                    </div>}

                    {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                        <div className="spinner-border text-primary" role="status"  >
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div></div>}
                    <SweetAlert
                        warning
                        title={"Atenção"}
                        onConfirm={() => {
                            this.delete_gerente(this.state.gerente_to_delete);
                        }}
                        onCancel={() => {
                            this.setState({ show_warning: false });
                        }}
                        show={this.state.show_warning}
                        confirmBtnText='Sim, desejo apagar'
                        cancelBtnText='Cancelar'
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        showCancel={true}
                    >
                        Ao retirar este gerente de sua ele não terá mais acesso aos seus produtos

                                </SweetAlert>
                    <SweetAlert
                        danger
                        title={"Erro"}
                        onConfirm={() => {
                            this.setState({ show_erro: false });
                        }}
                        show={this.state.show_erro}
                        confirmBtnText='OK'
                        confirmBtnBsStyle="primary"

                    >
                        {this.state.msgErro}

                    </SweetAlert>

                </div>
            </div>

        );
    }

    handlePageClick(page) {
        console.log(page.selected);
        if (page.selected + 1 != this.state.page) {
            this.setState({ page: page + 1 });
            this.get_gerentes(page.selected + 1, this.props.empresa_id);

        }
    }
}
const mapsStateToProps = (state) => (
    {
        user: state.AppReducer.user,
        token: state.AppReducer.token,
    }
);

export default withRouter(connect(mapsStateToProps, { logout, mudarUser, mudarTitle })(Gerentes));


